export const shadows = {
  main: "0px 2px 6px 0px rgba(0, 0, 0, 0.15)",
};
